import React from "react";
import {USE_DEVELOPMENT_FEATURES, USE_PRODUCTION_SERVER} from "../config";
import * as prosConnect from "./ProsConnect";
import BasicButton from "../components/BasicButton";
import {UiAvatar} from "./ProsCommonUi";
import {MAIN_VIEW_SETTINGS} from "../containers/Home";

export default function ProsSidebarTop(props) {
    const isLiveAndDev = USE_PRODUCTION_SERVER && USE_DEVELOPMENT_FEATURES
    const renderServerInfo =()=> {
        return <span className="text-xs">
            {USE_PRODUCTION_SERVER ? null : <span className="color-1st">TESTI SERVER </span>}
            {prosConnect.isSuperUserModeInUse() ? <span className="color-1st">SUPER-USER </span> : null}
            {isLiveAndDev && <span>LIVE & DEV</span>}
        </span>
    }

    function renderLogo(){
        return <figure className={"logo"}>
            <img src={"/images/prodect_light.svg"} alt={"Prodect-logo"}/>
        </figure>
    }

    const renderAvatar =()=>{
        return <>
            {USE_DEVELOPMENT_FEATURES ? <UiAvatar
                icon={"user"}
                className={"bg-color-user"}
            /> : renderLogo()}
            {props.sidebarOpen ? <div className={"sidebar-top-text"}>
                {prosConnect.getUserName()}<br/>
                <span className={"text-sm"}>{prosConnect.getUserEmail(true)}</span>
            </div> : null}
            {renderServerInfo()}
            {renderSidebarButtons()}
        </>
    }

    const renderSidebarButtons =()=>{
        if(!props.sidebarOpen) return null
        return <>
            {props.sidebarOpen ? <BasicButton
                btnClass={"primary"}
                icon={"gear"}
                action={()=>{
                    props.setMainView(MAIN_VIEW_SETTINGS)
                    props.resetSidebar()
                }}
                tooltip={["Tilin asetukset"]}
            /> : null}
            <div className={"element-set-v-xs"}>
                <BasicButton
                    icon={"times"}
                    action={()=>{
                        props.resetSidebar()
                    }}
                    size={"md"}
                    iconColor={"light"}
                />
                <BasicButton
                    btnClass={"primary"}
                    icon={"tack"}
                    action={()=>{
                        if(props.sidebarLocked) props.resetSidebar()
                        else props.toggleLockSidebar()
                    }}
                    selected={props.sidebarLocked}
                    size={"md"}
                    tooltip={[(props.sidebarLocked ? 'Vapauta' : 'Lukitse') + ' sivupaneeli', 'tooltip-bottom']}
                    className={"dom-hide dom-show_lg"}
                />
            </div>
        </>
    }

    return <div
            onClick={(evt) => {
                evt.preventDefault()
                evt.stopPropagation()
                if (typeof props.toggleSidebar === 'function') props.toggleSidebar()
                if (typeof props.resetView === 'function') props.resetView()
            }}
            className={"sidebar-top"}
            style={isLiveAndDev || prosConnect.isSuperUserModeInUse() ? {backgroundColor: 'var(--color-2nd-c7)'} : null}
        >
        {renderAvatar()}
    </div>
}